/**
 * WICHTIG: Bei Änderungen zyklsiche Abhängigkeiten beachten! 
 *  
 * <layout-enty.js>  -> *-register.js -> *.-resolver.js
 * *-register.js -> *.vue
 * *.vue -> *.resolver.js
 */
import FragmentNotFound from "./internal/fragment-not-found.vue";
import FragmentServerError from "./internal/fragment-server-error.vue";

import FragmentLabel from "./fragment-label.vue";
import FragmentHtml from "./fragment-html.vue";
import FragmentCodeListing from "./fragment-code-listing.vue";
import FragmentImage from "./fragment-image.vue";
import FragmentScrollMark from "./fragment-scroll-mark.vue";
import FragmentRestartExercise from "./fragment-restart-exercise.vue";

import FragmentGrid from "./fragment-grid.vue";
import FragmentContainer from "./fragment-container.vue"; 
import FragmentTable from "./fragment-table.vue"; 

import FragmentForm from "./fragment-form.vue";
import FragmentTextField from "./fragment-text-field.vue";
import FragmentDoubleField from "./fragment-double-field.vue";
import FragmentIntegerField from "./fragment-integer-field.vue";
import FragmentButton from "./fragment-button.vue";
import FragmentMatrix from "./fragment-matrix.vue";
import FragmentCheckBox from "./fragment-checkbox.vue";
import FragmentCheckBoxGroup from "./fragment-checkbox-group.vue";
import FragmentRationalField from "./fragment-rational-field.vue";
import FragmentRealField from "./fragment-real-field.vue";
import FragmenRadioButtonGroup from "./fragment-radiobutton-group.vue";
import FragmenRadioButton from "./fragment-radiobutton.vue";

import FragmentGfxBoard from "./gfx/fragment-gfx-board.vue";
import FragmentGfxForm from "./gfx/fragment-gfx-form.vue";
import FragmentGfxSubmit from "./gfx/fragment-gfx-submit.vue";

import FragmentGfx3dBoard from "./gfx3d/fragment-gfx3d-board.vue";

import GenericAlert from "./internal/generic-alert.vue";

import { registerFragmentComponent } from "./output-fragment-resolver";


/**
 * Erzeugt eine Komponenente, die einen Warnhinweis für den Autor erzeugt.
 * @param {String} message Die darzustellende Nachricht
 */
const newGenericAlertComponent = (function () {
    let counter = 0;
    return function (message) {
        counter++;
        return {
            ...GenericAlert,
            name: `generic-alert-component-${counter}`,
            data() {
                return {
                    message: message
                };
            }
        };
    };
}());


/**
 * registriert alle Components global und setzt deren Verknüpfung zum 
 * uiType. Später kann hier angesetzt werden, um einzelne Components
 * bei Spezial-Layouts auszutauschen (z.B. registerComponents(mixin) ).
 * 
 * Diese Funktion soll im Entry-Point des jeweiligen Layouts **einmalig**
 * aufgerufen werden.
 */
export const registerComponents = function (mixins = {}) {

    let registry = {
        "INTERNAL/fragment-not-found": FragmentNotFound,
        "INTERNAL/server-error": FragmentServerError,

        "mc/text/label": FragmentLabel,
        "mc/text/html": FragmentHtml,
        "mc/text/code": FragmentCodeListing,
        "mc/media/image": FragmentImage,
        "mc/gui-control/scrollmark": FragmentScrollMark,
        "mc/shortcuts/restart-exercise": FragmentRestartExercise, 

        // containers
        "mc/containers/grid": FragmentGrid,
        "mc/containers/container": FragmentContainer,
        "mc/containers/table": FragmentTable,

        // form container and inputs
        "mc/containers/form": FragmentForm,
        // single line input fields
        "mc/userinput/text-field": FragmentTextField,
        "mc/userinput/double-field": FragmentDoubleField,
        "mc/userinput/integer-field": FragmentIntegerField,
        "mc/userinput/rational-field": FragmentRationalField,
        "mc/userinput/real-field": FragmentRealField,
        // Buttons
        "mc/userinput/button": FragmentButton,
        "mc/userinput/checkbox": FragmentCheckBox,
        "mc/userinput/checkbox-group": FragmentCheckBoxGroup,
        "mc/userinput/radiobutton-group": FragmenRadioButtonGroup,
        "mc/userinput/radiobutton": FragmenRadioButton,
        // Matrix
        "mc/userinput/matrix": FragmentMatrix,
        
        // gfx
        "mc/gfx/board": FragmentGfxBoard,
        "mc/gfx/form": FragmentGfxForm,
        "mc/gfx/submit": FragmentGfxSubmit,

        // gfx3d
        "mc/gfx3d/board": FragmentGfx3dBoard,
        "mc/gfx3d/submit": newGenericAlertComponent("Der Gfx3D-Submit-Button kann nur im gfx3d-Layout verwendet werden."),
        "mc/gfx3d/form": newGenericAlertComponent("Das Gfx3D-Feedback-Formular kann nur im gfx3d-Layout verwendet werden."),
        "mc/gfx3d/board/modification": newGenericAlertComponent("Änderungen am Gfx3D-Board können nur im gfx3d-Layout vorgenommen werden."),

        // mixin to overide componennts
        ...mixins
    };

    Object.keys(registry).forEach(uiType => {
        let Component = registry[uiType];
        registerFragmentComponent(Component, uiType);
    });

};
